import EventDetails from '../event-details/event-details'

export default {
  EventDetails
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/resources/components.js